import { render, staticRenderFns } from "./FollowUpDialog.vue?vue&type=template&id=ab2875c2&"
import script from "./FollowUpDialog.vue?vue&type=script&lang=js&"
export * from "./FollowUpDialog.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports